import '@hotwired/turbo-rails';

import 'bootstrap-5';

import 'components/page_header.scss';
import 'animate.css';

import ShowDealRoom from 'bundles/connect/components/deal_room/show';
import SharingConnect from 'bundles/sharing_connect';
import MatchShow from 'bundles/connect/components/matches/match_show';
import MatchPhotoAndMap from 'bundles/connect/components/matches/review/match_photo_and_map';
import Search from 'bundles/connect/components/search';
import PasswordInput from 'bundles/connect/components/password_input';
import PhoneNumberInput from 'bundles/connect/components/phone_number_input';
import ProfileCompletion from 'bundles/connect/components/profile/completion';

// Work around for https://github.com/shakacode/react_on_rails/issues/991
window.ReactOnRails = window.ReactOnRails || require('react-on-rails').default;

import 'packs/global';

import { Application } from '@hotwired/stimulus';
import TableRowLinkController from 'bundles/connect/controllers/table_row_link_controller';
import ImageUploadPreviewController from 'bundles/connect/controllers/image_upload_preview_controller';
import FeedbackController from 'bundles/connect/controllers/feedback_controller';
import autoFormController from 'bundles/connect/controllers/auto_form_controller';
import BsTabDeeplink from 'bundles/connect/controllers/bs_tab_deeplink';
import Tooltip from 'bundles/connect/controllers/tooltip';
import VisibilityToggle from 'bundles/connect/controllers/visibility_toggle';
import DisableToggle from '../bundles/connect/controllers/disable_toggle';
import ClickVisibilityToggle from 'bundles/connect/controllers/click_visibility_toggle';
import Lightbox from 'bundles/connect/controllers/lightbox';
import BootstrapNavActive from 'bundles/connect/controllers/bootstrap_nav_active';
import DisableWithController from 'bundles/connect/controllers/disable_with_controller';
import ToastNotice from 'bundles/connect/controllers/toast_notice';
import Popper from 'bundles/connect/controllers/popper';
import FormValidationController from '../bundles/connect/controllers/form_validation_controller';
import PageSlidesController from '../bundles/connect/controllers/page_slides_controller';
import GoogleMapController from '../bundles/connect/controllers/google_map';
import RemoveOnDelete from '../bundles/connect/controllers/remove_on_delete';
import InterestedResponseFormController from 'bundles/connect/controllers/forms/interested_response_form_controller';
import PnSettings from 'bundles/connect/controllers/pn_settings';
import PnPropertyTags from 'bundles/connect/components/pn_support/property_tags';
import PnPropertyNotes from 'bundles/connect/components/pn_support/property_notes';
import PnAddToListButton from 'bundles/connect/components/pn_support/add_to_list_button';
import PnPropertyContacts from 'bundles/connect/components/pn_support/property_contacts';
import AlphamapsIframeResize from '../bundles/connect/controllers/alphamaps_iframe_resize';
import PropertyTabs from 'bundles/connect/controllers/property_tabs';
import DataPropertyContacts from 'bundles/connect/components/pn_support/data_property_contacts';

window.Stimulus = Application.start();
window.Stimulus.register('tableRowLink', TableRowLinkController);
window.Stimulus.register('imageUploadPreview', ImageUploadPreviewController);
window.Stimulus.register('feedback', FeedbackController);
window.Stimulus.register('autoForm', autoFormController);
window.Stimulus.register('tooltip', Tooltip);
window.Stimulus.register('visibilityToggle', VisibilityToggle);
window.Stimulus.register('disableToggle', DisableToggle);
window.Stimulus.register('clickVisibilityToggle', ClickVisibilityToggle);
window.Stimulus.register('bsTabDeeplink', BsTabDeeplink);
window.Stimulus.register('formValidation', FormValidationController);
window.Stimulus.register('lightbox', Lightbox);
window.Stimulus.register('bootstrapNavActive', BootstrapNavActive);
window.Stimulus.register('disable', DisableWithController);
window.Stimulus.register('toastNotice', ToastNotice);
window.Stimulus.register('popper', Popper);
window.Stimulus.register('pageSlides', PageSlidesController);
window.Stimulus.register('googleMap', GoogleMapController);
window.Stimulus.register('removeOnDelete', RemoveOnDelete);
window.Stimulus.register('interestedResponseForm', InterestedResponseFormController);
window.Stimulus.register('pnSettings', PnSettings);
window.Stimulus.register('alphamapsIframeResize', AlphamapsIframeResize);
window.Stimulus.register('propertyTabs', PropertyTabs);

ReactOnRails.setOptions({ turbo: true });

ReactOnRails.register({
  MatchPhotoAndMap,
  MatchShow,
  Search,
  SharingConnect,
  ShowDealRoom,
  PasswordInput,
  PhoneNumberInput,
  PnAddToListButton,
  PnPropertyContacts,
  PnPropertyNotes,
  PnPropertyTags,
  ProfileCompletion,
  DataPropertyContacts
});

if (module.hot) {
  module.hot.accept('bundles/sharing_connect', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept(
    'bundles/contact/requirements/requirements_form_container', () => ReactOnRails.reactOnRailsPageLoaded()
  );
  module.hot.accept('bundles/connect/components/search', () => ReactOnRails.reactOnRailsPageLoaded());
}

// Listen for P&N iframes messages
window.addEventListener(
  'message',
  (event) => {
    if (!Array.isArray(event?.data)) return;

    const [eventName, payload] = event?.data || [];

    switch (eventName) {
    case 'visit':
      // Listen for navigation changes from P&N iframes
      history.pushState({ pn: true }, '', `/connect${new URL(payload).pathname}`);
      break;
    case 'pn-redirect':
      // Listen for P&N redirections
      window.location.href = payload;
      break;
    default:
      return;
    }
  },
  false,
);

window.addEventListener('popstate', (e) => {
  if (e.state?.pn) window.location.reload();
});

document.addEventListener('turbo:frame-render', (e) => {
  if (e.target.querySelector('.js-react-on-rails-component')) ReactOnRails.reactOnRailsPageLoaded();
});
